import React, {Component} from 'react'
import {initializeApp} from 'firebase/app'
import {getAnalytics} from 'firebase/analytics'
import {getDatabase, ref, onValue, child, get} from 'firebase/database'
import {withCookies, Cookies} from 'react-cookie'
//import { TwitterApi } from "twitter-api-v2";
import Axios from 'axios'
import Sites from './stats/Sites'
import SiteMenu from './stats/SiteMenu'
import UnderBar from './stats/UnderBar'
import Charts from './stats/Charts'
import Growth from './stats/Growth'

class Stats extends Component {
  constructor(props) {
    super(props)

    let {cookies} = props

    let cookiesAll = cookies.getAll()
    let cookieArr = Object.values(cookiesAll)

    let siteNames = ['tastosis', 'baps', 'readToGoats', 'ytRadio', 'soCo', 'houseEdh']
    let siteReqs = [
      Axios.get('https://tastosis-65d3f-default-rtdb.firebaseio.com/analytics.json'),
      Axios.get('https://baps-1164a-default-rtdb.firebaseio.com/analytics.json'),
      Axios.get('https://readtogoats-default-rtdb.firebaseio.com/analytics.json'),
      Axios.get('https://ytradio-6ba83.firebaseio.com/analytics.json'),
      Axios.get('https://soco-94dfe-default-rtdb.firebaseio.com/analytics.json'),
      Axios.get('https://houseedh-default-rtdb.firebaseio.com/analytics.json'),
    ]
    this.state = {
      darkMode: false,
      siteAnalytics: {},
      dateGraphArr: [],
      datas: [],
      usage: {},
      activeName: 'readToGoats',
      hashtags: {},
      siteNames,
      siteReqs,
    }
  }

  componentDidMount() {
    if (this.state.darkMode) {
      document.body.style.backgroundColor = '#212024'
    }
    this.getOtherDBs()
    //this.getUsage()
    this.getHashtag()
  }

  getHashtag = () => {
    Axios.get(`http://jgab.me/hashtag`).then(res => {
      console.log('hashtag', res.data)
      let {hashtags} = this.state
      res.data.map(a => {
        hashtags[a.site] = a?.hashtag
      })
      this.setState({hashtags})
    })
  }

  setHashtag = () => {
    Axios.get(`http://jgab.me/setHashtag/%23baps`).then(res => {
      console.log('res', res)
    })
  }

  makeDateArr = (start, end) => {
    let arr = new Array()
    while (start <= end) {
      let year = start.getFullYear()
      let month = start.getMonth()
      let day = start.getDate()
      let dateString = `${year}/${month}/${day}`
      arr.push(dateString)
      start.setDate(start.getDate() + 1)
    }

    return arr
  }

  makeData = (name, data) => {
    let newDay = new Date()
    let today = new Date(newDay)
    let days90 = new Date(newDay)

    days90.setDate(today.getDate() - 90)
    let xArr = this.makeDateArr(days90, today)

    let dateGraphArr = []
    xArr.map(a => {
      let year = a.split('/')[0]
      let month = a.split('/')[1]
      let day = a.split('/')[2]
      let userIds = data?.views?.[year]?.[month]?.[day] || {}
      let numUsers = Object.keys(userIds).length
      let adjustedDate = `${year}/${Number(month) + 1}/${day}`
      dateGraphArr.push({adjustedDate, users: numUsers})
    })
    let {datas} = this.state
    datas[name] = dateGraphArr
    console.log('makeData')
    return datas
    //this.setState({datas})
  }

  getOtherDBs = () => {
    let {siteNames, siteReqs} = this.state
    Axios.all(siteReqs).then(res => {
      let allDatas = res.map((a, k) => {
        return this.makeData(siteNames[k], a.data)
      })
      console.log('allDatas', allDatas)
    })
  }

  getUsage = () => {
    Axios.get('https://readtogoats.com/metrics').then(res => {
      let usage = this.state?.usage || {}
      console.log('usage', usage)
      usage['readToGoats'] = res.data.sort((a, b) => b.timeStamp - a.timeStamp)
      this.setState({usage})
    })
  }

  makeActive = activeName => {
    this.setState({activeName})
  }

  render() {
    let {datas, activeName, usage, darkMode, hashtags} = this.state
    let {screenHeight, screenWidth} = this.props

    let sitesArr = [
      {
        name: 'readToGoats',
        short: '🐐',
        tickets: ['ad camp1'],
        usage: usage['readToGoats'],
        hashtag: hashtags['readToGoats'],
      },
      {name: 'baps', short: 'baps', tickets: ['normalize data'], hashtag: hashtags['baps']},
      {
        name: 'houseEdh',
        short: 'edh',
        tickets: ['mongo'],
        hashtag: hashtags['houseEdh'],
      },
      {name: 'soCo', short: 'soCo', tickets: [1, 2]},
      {
        name: 'tastosis',
        short: 'tasT',
        tickets: ['rest of games', 'ad camp 1'],
        hashtag: hashtags['tastosis'],
      },

      {
        name: 'ytRadio',
        short: 'ytR',
        tickets: ['goNext track', 'video add back'],
        hashtag: hashtags['ytRadio'],
      },

      {name: 'fogChess', short: 'fog', tickets: [1]},
      {name: 'inno', short: 'inno', tickets: [1]},
      {name: 'yoked', short: 'yok', tickets: []},
    ]

    return (
      <>
        <div className={'page'}>
          <div className={'flexRow'}>
            <Charts datas={datas} activeName={activeName} screenHeight={screenHeight} screenWidth={screenWidth} sitesArr={sitesArr} />
            {false && <Growth activeName={activeName} sitesArr={sitesArr} />}
          </div>
          {false && <SiteMenu makeActive={this.makeActive} activeName={activeName} sitesArr={sitesArr} />}
          {false && <UnderBar connectTwitter={this.connectTwitter} />}
          {false && <Sites sitesArr={sitesArr} />}
          <div className={'footer'}></div>
        </div>
      </>
    )
  }
}

export default withCookies(Stats)
